import React from 'react';
import styled from 'styled-components';
import { QRCodeCanvas } from 'qrcode.react';
import { Modal } from './Modal';

type QRCodeModalProps = {
    isOpen: boolean;
    onClose: () => void;
    value: string;
    valueLabel?: string;
    showValue?: boolean;
};

export const QRCodeModal: React.FC<QRCodeModalProps> = ({
    isOpen,
    onClose,
    value,
    valueLabel = 'Code',
    showValue = false,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="QR Code">
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <QRCodeCanvas value={value} size={300} />
                {showValue && (
                    <ValueText>
                        {valueLabel}: {value}
                    </ValueText>
                )}
            </ModalContent>
        </Modal>
    );
};

const ModalContent = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
`;

const ValueText = styled.div`
    padding: 20px;
    font-size: 16px;
    color: ${({ theme }) => theme.textColor};
    word-break: break-all;
    text-align: center;
`;
